enum Module {
  // Moudules name
  name = "participationModules",
  desc = "participationModules/",
}

enum Mutations {
  // Mutations types : Set, Remove, Add
  SetEventsAvailableTimes = "updateEventsAvailableTimes",
  SetEventsMyResponses = "updateUserVoteTimes",
  SetEventSchedularCountWithMyResponse = "setEventSchedularCountWithMyResponse",
  SetUserVote = "updateUserVote",
  SetEventPartRespStatus = 'setEventPartRespStatus',
}

enum Actions {
  // action types
  LoadEventsAvailableTime = "loadEventsAvailableTime",
  LoadEventsMyResponses = "loadUserVote",
  LoadEventSchedularCountWithMyResponse = "loadEventSchedularCountWithMyResponse",
  HandMyEventVote = "setUserVote",
  HandMyEventVoteNone = "setUserVoteNone",
}

enum Getters {
  // getters types
  MyEventsAvailableDays = "getEventsAvailableTimes",
  MyEventsResponses = "getEventsResponses",
  EventSchedularCountWithMyResponse = "getEventSchedularCountWithMyResponse",
  TimelineRowGroupHeaderList = "getTimelineRowGroupHeaderList",
  TimelineRowHeaderList = "getTimelineRowHeaderList",
  TimelineDataList = "getTimelineDataList",
  EventPartRespStatus = 'getEventPartRespStatus'
}

enum Params {
  SortByAgreeCount = "1",
  SortByStartTime = "2",
}

export { Module, Actions, Mutations, Getters, Params };
